import React from 'react';

export default function Home() {
  return (
    <div>
      <h2>Welcome to the Home Page</h2>
      <p>This is the home content.</p>
    </div>
  );
}
